import { render } from "./EditBasicData.vue?vue&type=template&id=1a267a3c"
import script from "./EditBasicData.vue?vue&type=script&lang=js"
export * from "./EditBasicData.vue?vue&type=script&lang=js"

import "./EditBasicData.vue?vue&type=style&index=0&id=1a267a3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__